// extracted by mini-css-extract-plugin
export default {"container":"form-group_container__6FbqF","truncate-table":"form-group_truncate-table__B2vbK","table-text-faded":"form-group_table-text-faded__GzVl+","formGroup":"form-group_formGroup__yQ0fS","info":"form-group_info__tom9a","title":"form-group_title__SFVZi","description":"form-group_description__l79Kd","formRows":"form-group_formRows__CMJtS","withSeparator":"form-group_withSeparator__GMGrv"};
    if(module.hot) {
      // 1793877086006
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  